import { modifier } from 'ember-modifier';

export default modifier(
    function onClickOutside(element, properties, { triggerKeyword, handler, selector }) {
        let handleClick = (event) => {
            let elementToUse = selector ? document.querySelector(selector) : element;
            if (
                elementToUse &&
                ((triggerKeyword && !event.target.id.includes(triggerKeyword)) || !triggerKeyword) &&
                !elementToUse.contains(event.target)
            )
                handler();
        };

        document.addEventListener('click', handleClick);

        // This function will occur when the element is removed from the dom
        return () => document.removeEventListener('click', handleClick);
    },
    { eager: false },
);
